import { getData } from '@/utils/apiTools';
import { Industry } from '@/models/Tags';

const industriesLabelCollator = new Intl.Collator('de', { sensitivity: 'base' });

// eslint-disable-next-line import/prefer-default-export
export const getIndustries = async (): Promise<Industry[]> => {
  const industries = await getData('/v1/tags/industries');
  if (!Array.isArray(industries)) {
    return [];
  }
  return [...industries].sort((a, b) => industriesLabelCollator.compare(a.label, b.label));
};
